import { useEffect, useState } from "react";
import { Trash2, MailOpen, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, asArray, errMsg, formatDate } from "../../lib/api";
import { Empty, Pill } from "./shared";

export const EnquiriesTab = ({ onChange }) => {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/enquiries").then((r) => setItems(asArray(r))).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const toggle = async (e) => {
    try { await api.patch(`/admin/enquiries/${e.id}`, { status: e.status === "new" ? "read" : "new" }); load(); onChange(); }
    catch (err) { toast.error(errMsg(err)); }
  };
  const remove = async (e) => {
    if (!window.confirm("Delete this enquiry?")) return;
    try { await api.delete(`/admin/enquiries/${e.id}`); toast.success("Deleted"); load(); onChange(); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div>
      <h2 className="font-display font-bold text-2xl mb-6">Contact enquiries</h2>
      {!items.length && <Empty testid="admin-enquiries-empty">No enquiries yet.</Empty>}
      <div className="space-y-3">
        {items.map((e) => (
          <div key={e.id} data-testid={`admin-enquiry-${e.id}`} className={`rounded-2xl border p-5 ${e.status === "new" ? "bg-white border-[var(--brass)]" : "bg-white/60 border-ink/10"}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <p className="font-semibold">{e.name} {e.company && <span className="font-normal text-ink/60">· {e.company}</span>}</p>
                <p className="text-sm text-ink/70 mt-1">
                  <a href={`mailto:${e.email}`} className="underline">{e.email}</a>{e.phone && <> · <a href={`tel:${e.phone}`}>{e.phone}</a></>}
                </p>
              </div>
              <div className="flex items-center gap-2">
                {e.entity_type && <Pill>{e.entity_type}</Pill>}
                <Pill tone={e.status === "new" ? "amber" : "neutral"}>{e.status}</Pill>
                <span className="text-xs text-ink/60">{formatDate(e.created_at)}</span>
              </div>
            </div>
            <p className="mt-3 text-ink/80 whitespace-pre-line">{e.message}</p>
            <div className="mt-4 flex gap-2">
              <button data-testid={`admin-enquiry-toggle-${e.id}`} onClick={() => toggle(e)} className="inline-flex items-center gap-1 rounded-full border border-ink/20 px-4 py-1.5 text-sm">
                {e.status === "new" ? <><MailOpen className="w-4 h-4" /> Mark read</> : <><Mail className="w-4 h-4" /> Mark new</>}
              </button>
              <button data-testid={`admin-enquiry-delete-${e.id}`} onClick={() => remove(e)} className="inline-flex items-center gap-1 rounded-full text-red-700 px-3 py-1.5 text-sm hover:bg-red-50"><Trash2 className="w-4 h-4" /> Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
